<template>
  <div class="runmode">
    <transition name="fade">
      <div v-show="showComponent">
        <!-- 戻る/進む -->
        <div class="goback">
          <div class="back" v-if="backDisabled"><button type="button" v-on:click="backPathstep"></button></div>
          <div class="go" v-if="goDisabled"><button type="button" v-on:click="goPathstep"></button></div>
        </div>

        <component v-bind:is="currentView" :pathstep="pathstepData" :isScrollIconVisible="isScrollIconVisible"
                   v-on:endAct="endAct" v-on:stopAct="stopAct"
                   v-on:showMicrophoneErrorDialog="showMicErrorDialog"
                   v-on:mounted="startBindView"
                   v-on:showScrollIcon="showScrollIcon"></component>
      </div>
    </transition>

    <!-- アクティビティ完了画面 -->
    <ActivityCompletion v-if="showCompletionView" :lessonIndex="completionLessonIndex" :pathTitle="completionPathTitle" :answerRate="completionAnswerRate" :ok="completionOk" :ng="completionNg" :skip="completionSkip" :total="completionTotal" :nextUnitNo="completionNextUnitNo" :nextUnitTitle="completionNextUnitTitle" :nextLessonIndex="completionNextLessonIndex" :nextPathTitle="completionNextPathTitle" v-on:clickButton="clickButtonCompletion"></ActivityCompletion>
    <!-- スコアリセットダイアログ -->
    <ScoreReset v-if="showScoreReset" @clickButton="clickScoreResetButton"/>
    <!-- マイク設定確認ダイアログ -->
    <MicrophoneErrorDialog v-if="showMicrophoneErrorDialog" @startLesson="startLessonFromMicErrorDialog" @clickMicrophoneSetting="showMicSelect" @lessonContinue="lessonContinue" @showError="emitShowError" :productInfo="productInfo" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import * as constants from "@/mixin/constants";
import * as storeConstants from "@/store/constants";
import common from "@/mixin/common";
import http from "@/mixin/http";

import RunmodeLoading from "@/components/RunmodeLoading";
import ActivityCompletion from "@/components/ActivityCompletion";
import ScoreReset from "@/components/ScoreReset";
import MicrophoneErrorDialog from "@/components/MicrophoneSettingDialog";
import NR1 from "@/components/runmode/NR1";
import NR3 from "@/components/runmode/NR3";
import A1 from "@/components/runmode/A1";
import A1Q from "@/components/runmode/A1Q";
import A3 from "@/components/runmode/A3";
import Tile from "@/components/runmode/Tile";
import P1 from "@/components/runmode/P1";
import PSpeech from "@/components/runmode/PSpeech";
import TDic from "@/components/runmode/TDic";
import TPro from "@/components/runmode/TPro";

export default {
  name: "runmode",
  props: {
    jsonData: Object,
    productInfo: Object,
    showLessonScore: Boolean,
    showSetting: Boolean,
    showMicrophoneSelect: Boolean,
    clickToolbarLogo: Boolean,
    isDocomo: Boolean,
    showProgressHandOver: Boolean
  },
  data: function() {
    return {
      currentView: "",
      nextView: "",
      currentMode: "",
      pathstepData: null,
      levelJson: null,
      milestone: false,
      milestoneQuestion: [],
      showComponent: false,
      // ボタン制御用
      backDisabled: false,
      goDisabled: false,
      // アクティビティ完了画面用
      showCompletionView: false,
      completionLessonIndex: 0,
      completionPathTitle: "",
      completionAnswerRate: 0,
      completionOk: 0,
      completionNg: 0,
      completionSkip: 0,
      completionTotal: 0,
      completionNextUnitNo: 0,
      completionNextUnitTitle: "",
      completionNextLessonIndex: 0,
      completionNextPathIndex: 0,
      completionNextPathTitle: "",
      completionViewContinue: false,
      // マイク設定確認ダイアログ用
      showMicrophoneErrorDialog: false,
      // スコアリセットダイアログ用
      showScoreReset: false,
      // 次に実施するPathstepIndex
      nextPathstepIndex: -1,
      // スクロールアイコン表示フラグ
      isScrollIconVisible: false,
      // スクロール実施済みフラグ
      isScrolled: false,
      // スクロールアイコン非表示タイマー
      scrollIconVisibleTimer: null
    };
  },
  components: {
    RunmodeLoading,
    ActivityCompletion,
    ScoreReset,
    MicrophoneErrorDialog,
    NR1,
    NR3,
    A1,
    A1Q,
    A3,
    Tile,
    P1,
    PSpeech,
    TDic,
    TPro
  },
  mixins: [
    common,
    http
  ],
  computed: {
    ...mapGetters([
      "levelNo",
      "unitNo",
      "lessonIndex",
      "pathIndex",
      "pathstepIndex",
      "lessonJson",
      "sreUse",
      "showPinchIn",
      "textSize"
    ])
  },
  methods: {
    /**
     * ホーム画面へ遷移させるため、親へ通知
     */
    endPath: function() {
      this.log("Runmode start endLesson");
      this.$emit("endLesson");
    },
    /**
     * エラー表示のため、親へ通知
     */
    emitShowError: function(message, buttonKind) {
      this.log("Runmode start showError");
      this.showMicrophoneErrorDialog = false;
      this.$emit("showError", message, buttonKind);
    },
    /**
     * マイク設定画面を表示するため、親へ通知
     */
    showMicSelect: function() {
      this.log("Runmode start showMicSelect");
      this.$emit("showMicrophoneSelect", false);
    },
    /**
     * 進捗引継ぎ確認画面表示のため、親へ通知
     */
    emitShowProgressHandOver: function(unitNo, lessonIndex, pathIndex, pathstepIndex, json) {
      this.log("Runmode start emitShowProgressHandOver");
      this.$emit("showProgressHandOver", unitNo, lessonIndex, pathIndex, pathstepIndex, json);
    },
    /**
     * コンポーネントを切り替える
     * 前回と同じコンポーネントを表示する場合、mountedが呼ばれないため、
     * 別画面を表示後に切り替えるようにする
     */
    startBindView: function() {
      this.log("Runmode start startBindView");

      // フェードイン
      var self = this;
      setTimeout(function() {
        self.currentView = self.nextView;
        self.showComponent = true;

        clearTimeout(self.scrollIconVisibleTimer);
        self.isScrolled = false;
        self.isScrollIconVisible = false;

        // スコアを確認
        var pathstepIndex = self.$store.getters.pathstepIndex;
        var currentPath = self.$store.getters.currentPath;
        var pathstep = currentPath.pathsteps[pathstepIndex];

        var val = pathstep.ok + pathstep.ng;
        if (val == 0) {
          var apiData = self.createProgressValue();

          // 進捗/スコアをDBに保存
          self.doSetKeyValue(apiData).then(function() {
            // スコアを初期化
            self.$store.dispatch("setPathstepAllSkip");

            return new Promise(function(resolve, reject) {
              // コンテンツ全体進捗設定処理
              self.setAllProgress().then(function() {
                // state更新
                self.log("set LessonState: " + storeConstants.LESSON_STATE_START);
                self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_START);
              }).catch(function(message) {
                reject(message);
              });
            });
          }).catch(function(message) {
            if (message.length != 0) {
              self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
            }
          });
        } else {
          // スコアリセットダイアログを表示
          self.showScoreReset = true;
        }
      }, 500);
    },
    /**
     * 出題が終了
     * 子コンポーネントから上がってくるイベント
     */
    endAct: function() {
      this.log("Runmode start endAct");

      var self = this;
      var apiData = this.createScoreValue();

      // 進捗/スコアをDBに保存
      this.doSetKeyValue(apiData).then(function() {
        return new Promise(function(resolve, reject) {
          // コンテンツ全体進捗設定処理
          self.setAllProgress().then(function() {
            // 自動的に次に進むか確認
            if (self.$store.getters.autoScreenTransition !== "true") {
              return;
            }
            // 最終問題か確認
            if (self.goDisabled) {
              // 次の問題へ
              var newIndex = self.pathstepIndex + 1;
              self.startLesson(self.unitNo, self.lessonIndex, self.pathIndex, newIndex, self.lessonJson);
            } else {
              // state更新
              self.log("set LessonState: " + storeConstants.LESSON_STATE_END);
              self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_END);

              // アクティビティ完了画面を表示
              self.doShowCompletionView();
            }
          }).catch(function(message) {
            reject(message);
          });
        });
      }).catch(function(message) {
        if (message.length != 0) {
          self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
        }
      });
    },
    /**
     * 出題を中断
     * 子コンポーネントから上がってくるイベント
     *
     * 以下の操作に発生する想定
     * ・前へ/次へボタン押下時
     * ・レッスンスコア画面で、レッスンを選択した時
     * ・ツールバーのロゴ押下時
     */
    stopAct: function() {
      this.log("Runmode start stopAct");

      // ツールバーのログを押下して出題を中断した場合
      if (this.clickToolbarLogo) {
        // ホーム画面を表示する
        this.endPath();
        return;
      }

      var self = this;
      var apiData = this.createScoreValue();

      // 進捗/スコアをDBに保存
      this.doSetKeyValue(apiData).then(function() {
        return new Promise(function(resolve, reject) {
          // コンテンツ全体進捗設定処理
          self.setAllProgress().then(function() {
            if (self.nextPathstepIndex == -1) {
              return;
            }

            self.startLesson(self.unitNo, self.lessonIndex, self.pathIndex, self.nextPathstepIndex, self.lessonJson);

            // 初期化
            self.nextPathstepIndex = -1;
          }).catch(function(message) {
            reject(message);
          });
        });
      }).catch(function(message) {
        if (message.length != 0) {
          self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
        }
      });
    },
    /**
     * マイク設定確認ダイアログを表示
     * 子コンポーネントから上がってくるイベント
     */
    showMicErrorDialog: function() {
      this.log("Runmode start showMicErrorDialog");

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);

      this.showMicrophoneErrorDialog = true;
    },
    /**
     * 前のPathstepへ移動
     */
    backPathstep: function() {
      this.log("Runmode start backPathstep");

      // ボタン連打用処理
      switch (this.$store.getters.lessonState) {
        case storeConstants.LESSON_STATE_START:
        case storeConstants.LESSON_STATE_RESTART:
          // 処理継続
          break;
        default:
          // 何もしない
          return;
      }

      // 次のPathstepIndexを設定
      this.setNextPathstepIndex(this.pathstepIndex - 1);

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_STOP);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_STOP);
    },
    /**
     * 次のPathstepへ移動
     */
    goPathstep: function() {
      this.log("Runmode start goPathstep");

      // ボタン連打用処理
      switch (this.$store.getters.lessonState) {
        case storeConstants.LESSON_STATE_START:
        case storeConstants.LESSON_STATE_RESTART:
          // 処理継続
          break;
        default:
          // 何もしない
          return;
      }

      // 次のPathstepIndexを設定
      this.setNextPathstepIndex(this.pathstepIndex + 1);

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_STOP);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_STOP);
    },
    /**
     * 前/次ボタンの表示制御
     */
    setButtonDisabled: function() {
      var len = 0;
      if (this.milestone) {
        len = constants.MILESTONE_QUESTION_COUNT - 1;
      } else {
        len = this.lessonJson.paths[this.pathIndex].pathsteps.length - 1;
      }

      if (len == this.pathstepIndex && this.pathstepIndex == 0) {
        // 前／次問題がない場合
        this.backDisabled = false;
        this.goDisabled = false;
      } else if (this.pathstepIndex == 0) {
        // 始め
        this.backDisabled = false;
        this.goDisabled = true;
      } else if (len == this.pathstepIndex) {
        // 最後
        this.backDisabled = true;
        this.goDisabled = false;
      } else {
        this.backDisabled = true;
        this.goDisabled = true;
      }
    },
    /**
     * 次のPathstepIndexを設定
     * 子コンポーネントの終了処理完了後(stopAct)に、次のレッスンを開始するため、
     * 次のPathstepIndexを保持する
     */
    setNextPathstepIndex: function(newIndex) {
      this.log("Runmode start setNextPathstepIndex: " + newIndex);
      this.nextPathstepIndex = newIndex;
    },
    /**
     * レッスン開始前に、storeにデータを保存
     */
    startLesson: function(newUnitNo, newLessonIndex, newPathIndex, newPathstepIndex, newLessonJson) {
      this.log("Runmode start startLesson newUnitNo: " + newUnitNo + ", newLessonIndex: " + newLessonIndex + ", newPathIndex: " + newPathIndex + ", newPathstepIndex: " + newPathstepIndex);

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_PREPARE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);

      this.showScoreReset = false;

      this.$store.dispatch("setUnitNo", newUnitNo);
      this.$store.dispatch("setLessonIndex", newLessonIndex);
      this.$store.dispatch("setPathIndex", newPathIndex);
      this.$store.dispatch("setPathstepIndex", newPathstepIndex);
      this.$store.dispatch("setLessonJson", newLessonJson);

      // アクティビティ完了画面で"続行"押下された場合
      if (this.completionViewContinue) {
        this.completionViewContinue = false;

        // マイルストーンか確認
        if (newLessonJson.paths[newPathIndex].title === constants.MILESTONE_TITLE) {
          this.milestone = true;
          // 問題があるか確認
          var params = { levelNo: this.levelNo, unitNo: newUnitNo };
          this.milestoneQuestion = this.$store.getters.filterMilestone(params);
          if (this.milestoneQuestion.length == 0) {
            this.createMilestoneQuestion();
            return;
          }

          // storeのレッスンスコアを初期化
          var params = { milestoneQuestion: this.milestoneQuestion, levelJson: this.levelJson };
          this.$store.dispatch("initLessonScoreForMilestone", params);
        } else {
          this.milestone = false;
        }
      }

      this.doStartLesson();
    },
    /**
     * レッスン開始
     */
    doStartLesson: function() {
      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_PREPARE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);

      var self = this;

      // フェードアウト
      this.showComponent = false;

      // 全解答/日本語翻訳表示の値をリセット
      this.$store.dispatch("setShowJapanese", false);
      this.$store.dispatch("setShowAllAnswer", false);

      setTimeout(function() {
        // コンポーネントに渡すデータを設定
        if (self.milestone) {
          // マイルストーンの場合、問題データから判断
          for (var question of self.milestoneQuestion) {
            var key = Object.keys(question);
            var keySplit = key[0].split("-");
            if (keySplit[4] === self.pathstepIndex.toString()) {
              var json = JSON.parse(JSON.stringify(question));
              self.log("milestoneQuestion: " + json[key[0]]);
              var split = json[key[0]].split("-");
              var unitJson = self.getUnitJson(self.levelJson, Number(split[1]));
              self.pathstepData = unitJson.lessons[Number(split[2])].paths[Number(split[3])].pathsteps[Number(split[4])];

              // ツールバーのデータ更新
              for (var child of self.$parent.$children) {
                if (child.$options.name === "toolbar") {
                  child.setNote(Number(split[0]), Number(split[1]), Number(split[2]), Number(split[3]), Number(split[4]));
                  break;
                }
              }

              break;
            }
          }
        } else {
          self.pathstepData = self.lessonJson.paths[self.pathIndex].pathsteps[self.pathstepIndex];
        }

        // ボタン表示制御
        self.setButtonDisabled();

        // 使用するコンポーネントを設定
        self.setRunmode(self.pathstepData.mode);

        self.currentView = "RunmodeLoading";
      }, 500);
    },
    /**
     * modeから使用するコンポーネントを設定
     */
    setRunmode: function(mode) {
      this.log("Runmode start setRunmode: " + mode);

      this.currentMode = mode;

      switch (mode) {
        case constants.RUNMODE_A1:
        case constants.RUNMODE_A1O:
        case constants.RUNMODE_B:
        case constants.RUNMODE_BO:
        case constants.RUNMODE_NR5:
          this.nextView = "A1";
          break;
        case constants.RUNMODE_A1Q:
          this.nextView = "A1Q";
          break;
        case constants.RUNMODE_TILE:
        case constants.RUNMODE_STILE:
          this.nextView = "Tile";
          break;
        case constants.RUNMODE_P:
        case constants.RUNMODE_PNT:
          this.nextView = "P1";
          break;
        case constants.RUNMODE_PSPEECH:
        case constants.RUNMODE_PNTSPEECH:
          this.nextView = "PSpeech";
          break;
        case constants.RUNMODE_TDIC:
          this.nextView = "TDic";
          break;
        case constants.RUNMODE_TPRO:
          this.nextView = "TPro";
          break;
        case constants.RUNMODE_A3:
        case constants.RUNMODE_A3O:
          this.nextView = "A3";
          break;
        case constants.RUNMODE_NR1:
        case constants.RUNMODE_NR2:
          this.nextView = "NR1";
          break;
        case constants.RUNMODE_NR3:
        case constants.RUNMODE_NR3_NT:
          this.nextView = "NR3";
          break;
        default:
          break;
      }
    },
    /**
     * スコアのAPI送信用のデータを作成
     */
    createScoreValue: function() {
      // スコアを取得
      var pathScore = this.$store.getters.currentPath;
      var pathstepScore = pathScore.pathsteps[this.pathstepIndex];

      // API送信のデータを作成
      var score = this.createScoreDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex, pathstepScore.ok, pathstepScore.ng, pathstepScore.skip);
      var apiData = '{"data":[' + score + "]}";

      return apiData;
    },
    /**
     * 進捗のAPI送信用のデータを作成
     */
    createProgressValue: function() {
      // storeの進捗を更新
      var params = { levelNo: this.levelNo, unitNo: this.unitNo, lessonIndex: this.lessonIndex, pathIndex: this.pathIndex, pathstepIndex: this.pathstepIndex };
      this.$store.dispatch("updateProgress", params);

      // API送信のデータを作成
      var progress = this.createProgressDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, this.pathstepIndex);

      // 学習状態更新
      var studyState = this.createStudyStatusDataForApi(true);

      var apiData = '{"data":[' + progress + ", " +  studyState + ']}';

      return apiData;
    },
    /**
     * マイルストーンの問題抽出処理
     */
    createMilestoneQuestion: function() {
      this.log("Runmode start createMilestoneQuestion");

      var self = this;
      var unitJson = this.getUnitJson(this.levelJson, this.unitNo);
      var newMilestone = this.createMilestone(unitJson, this.levelNo, this.unitNo);

      // storeに保存
      var params = { levelNo: this.levelNo, unitNo: this.unitNo, question: [] };
      for (var item of newMilestone) {
        var val = { data: item };
        params.question.push(val);
      }
      this.$store.dispatch("updateMilestone", params);

      // json作成
      var question = this.createMilestoneDataForApi(this.levelNo, this.unitNo, newMilestone);
      var apiData = '{"data":[' + question + "]}";

      var json = JSON.parse(apiData);
      this.milestoneQuestion = json.data;

      // API送信
      this.doSetKeyValue(apiData).then(function() {
        // storeのレッスンスコアを初期化
        var params = { milestoneQuestion: self.milestoneQuestion, levelJson: self.levelJson };
        self.$store.dispatch("initLessonScoreForMilestone", params);

        return new Promise(function(resolve, reject) {
          // コンテンツ全体進捗設定処理
          self.setAllProgress().then(function() {
            // レッスン開始
            self.doStartLesson();
          }).catch(function(message) {
            reject(message);
          });
        });
      }).catch(function(message) {
        if (message.length != 0) {
          self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
        }
      });
    },
    /**
     * key-value設定APIを実行
     */
    doSetKeyValue: function(datajson) {
      this.log("Runmode start doSetKeyValue");
      var self = this;

      return new Promise(function(resolve, reject) {
        // key-value設定API
        self.setKeyValue(self.productInfo.code, datajson).then(function(response) {
          self.log("Runmode doSetKeyValue resultCode: " + response.result_code);
          switch (response.result_code) {
            case 'OK':
              resolve();
              break;
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message);
              break;
            default:
              resolve();
              break;
          }
        }).catch(function(err) {
          resolve();
        });
      });
    },
    /**
     * 進捗率設定APIを実行
     */
    doRegisterProgress: function(progress) {
      this.log("Runmode start doRegisterProgress");
      var self = this;

      return new Promise(function(resolve, reject) {
        // 進捗率設定API
        self.registerProgress(self.productInfo.code, progress).then(function(response) {
          self.log("Runmode registerProgress resultCode: " + response.result_code);
          switch (response.result_code) {
            case 'OK':
              resolve();
              break;
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message);
              break;
            default:
              resolve();
              break;
          }
        }).catch(function(err) {
          resolve();
        });
      });
    },
    /**
     * アクティビティ完了画面を表示
     */
    doShowCompletionView: function() {
      this.log("Runmode start doShowCompletionView");

      var pathScore = this.$store.getters.currentPath;

      this.completionLessonIndex = this.lessonIndex;
      this.completionPathTitle = pathScore.title;
      this.completionAnswerRate = pathScore.answerRate;
      this.completionOk = pathScore.ok;
      this.completionNg = pathScore.ng;
      this.completionSkip = pathScore.skip;
      this.completionTotal = pathScore.total;

      var unitJson = this.getUnitJson(this.levelJson, this.unitNo);
      var pathLen = this.lessonJson.paths.length - 1;
      var lessonLen = unitJson.lessons.length - 1;
      var unitLen = this.levelJson.units.length - 1;
      var unitIndex = this.getUnitIndex(this.levelJson, this.unitNo);

      this.completionNextUnitNo = this.unitNo;
      this.completionNextUnitTitle = unitJson.title;
      this.completionNextLessonIndex = this.lessonIndex;

      if (pathLen == this.pathIndex) {
        if (lessonLen == this.lessonIndex) {
          var json = null;
          if (unitLen == unitIndex) {
            // 始めのunit
            json = this.levelJson.units[0];
          } else {
            // 次のunit
            json = this.levelJson.units[unitIndex + 1];
          }
          this.completionNextUnitNo = json.unitNo;
          this.completionNextUnitTitle = json.title;
          this.completionNextLessonIndex = 0;
          this.completionNextPathIndex = 0;
          this.completionNextPathTitle = json.lessons[0].paths[0].title;
        } else {
          // 次のlesson
          this.completionNextLessonIndex = this.lessonIndex + 1;
          this.completionNextPathIndex = 0;
          this.completionNextPathTitle = unitJson.lessons[this.lessonIndex + 1].paths[0].title;
        }
      } else {
        // 次のpath
        this.completionNextPathIndex = this.pathIndex + 1;
        this.completionNextPathTitle = unitJson.lessons[this.lessonIndex].paths[this.pathIndex + 1].title;
      }

      this.showCompletionView = true;
    },
    /**
     * アクティビティ完了画面でボタン押下された場合の処理
     */
    clickButtonCompletion: function(buttonkind) {
      this.log("Runmode start clickButtonCompletion");

      this.showCompletionView = false;
      switch (buttonkind) {
        case "home":
          this.endPath();
          break;
        case "repeat":
          this.repeatLesson();
          break;
        case "continue":
          this.completionViewContinue = true;

          // 最後に実施したpathStepを取得
          var params = { levelNo: this.levelNo, unitNo: this.completionNextUnitNo, lessonIndex: this.completionNextLessonIndex, pathIndex: this.completionNextPathIndex };
          var pathStepIndex = this.$store.getters.filterProgress(params);
          var unitJson = this.getUnitJson(this.levelJson, this.completionNextUnitNo);
          var lessonJson = unitJson.lessons[this.completionNextLessonIndex];

          if (pathStepIndex == -1) {
            this.startLesson(this.completionNextUnitNo, this.completionNextLessonIndex, this.completionNextPathIndex, 0, lessonJson);
          } else {
            // 進捗引継ぎ確認画面を表示
            this.emitShowProgressHandOver(this.completionNextUnitNo, this.completionNextLessonIndex, this.completionNextPathIndex, pathStepIndex, lessonJson);
          }
          break;
        default:
          break;
      }
    },
    /**
     * レッスンを繰り返す
     */
    repeatLesson: function() {
      this.log("Runmode start repeatLesson");

      // storeのスコアをリセット
      this.$store.dispatch("setPathAllReset");

      // json作成
      var pathstepLength = this.lessonJson.paths[this.pathIndex].pathsteps.length;
      var score = this.createResetScoreDataForApi(this.levelNo, this.unitNo, this.lessonIndex, this.pathIndex, pathstepLength);
      var apiData = '{"data":[' + score + "]}";

      var self = this;
      // 進捗/スコアをDBに保存
      this.doSetKeyValue(apiData).then(function() {
        return new Promise(function(resolve, reject) {
          // コンテンツ全体進捗設定処理
          self.setAllProgress().then(function() {
            // レッスン開始
            self.startLesson(self.unitNo, self.lessonIndex, self.pathIndex, 0, self.lessonJson);
          }).catch(function(message) {
            reject(message);
          });
        });
      }).catch(function(message) {
        if (message.length != 0) {
          self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
        }
      });
    },
    /**
     * 音声停止処理
     */
    audioPause: function() {
      this.log("Runmode start audioPause");

      this.$emit("audioPause");
    },
    /**
     * マイク設定確認ダイアログを閉じて、レッスンを再実施
     */
    startLessonFromMicErrorDialog: function() {
      this.log("Runmode start startLessonFromMicErrorDialog");
      this.showMicrophoneErrorDialog = false;
      this.doStartLesson();
    },
    /**
     * マイク設定確認ダイアログを閉じて、レッスンを再開
     */
    lessonContinue: function() {
      this.log("Runmode start lessonContinue");

      this.showMicrophoneErrorDialog = false;

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * レッスン準備
     */
    prepareLesson: function() {
      this.log("Runmode start prepareLesson");

      // マイルストーンか確認
      if (this.lessonJson.paths[this.pathIndex].title === constants.MILESTONE_TITLE) {
        this.milestone = true;
        // 問題があるか確認
        var params = { levelNo: this.levelNo, unitNo: this.unitNo };
        this.milestoneQuestion = this.$store.getters.filterMilestone(params);
        if (this.milestoneQuestion.length == 0) {
          this.createMilestoneQuestion();
          return;
        }

        // storeのレッスンスコアを初期化
        var params = { milestoneQuestion: this.milestoneQuestion, levelJson: this.levelJson };
        this.$store.dispatch("initLessonScoreForMilestone", params);
      }

      this.doStartLesson();
    },
    /**
     * スコアリセットダイアログのボタン押下時の処理
     */
    clickScoreResetButton: function(kind) {
      this.log("Runmode start clickScoreResetButton: " + kind);

      if (kind === "home") {
        // state更新
        this.log("set LessonState: " + storeConstants.LESSON_STATE_STOP);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_STOP);

        // ホーム画面へ遷移
        this.showScoreReset = false;
        this.endPath();
      } else if (kind === "lessonScore") {
        // レッスンスコアを表示
        this.$emit("showLessonScore");
      } else {
        var self = this;
        var apiData = this.createProgressValue();

        // 進捗/スコアをDBに保存
        this.doSetKeyValue(apiData).then(function() {
          self.showScoreReset = false;

          // スコアを初期化
          self.$store.dispatch("setPathstepAllSkip");

          return new Promise(function(resolve, reject) {
            // コンテンツ全体進捗設定処理
            self.setAllProgress().then(function() {
              // state更新
              self.log("set LessonState: " + storeConstants.LESSON_STATE_START);
              self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_START);
            }).catch(function(message) {
              reject(message);
            });
          });
        }).catch(function(message) {
          if (message.length != 0) {
            self.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
          }
        });
      }
    },
    /**
     * コンテンツ全体進捗設定処理
     */
    setAllProgress: function() {
      this.log("Runmode start setAllProgress");

      // 実行環境がdocomo版Androidアプリの場合は終了
      if (this.isDocomo) {
        return Promise.resolve();
      }

      // コンテンツ全体進捗設定処理
      var progress = this.$store.getters.allProgress;
      return this.doRegisterProgress(progress);
    },
    /**
     * 学習状態更新
     */
    updateStudyState: function() {
      this.log("Runmode start updateStudyState");

      var self = this;
      var apiData = this.createStudyStateValue();

      this.doSetKeyValue(apiData).then(function() {
        // 学習状態更新
        self.log("set StudyState: " + true);
      }).catch(function(message) {
        self.log("set StudyState Error");
      });
    },
    /**
     * スクロールアイコン表示処理
     *
     * @param {Object} targetElem スクロール対象要素
     */
    showScrollIcon: function(targetElem) {
      if (!this.isEnvironmentPc() && !this.isScrolled) {
        this.isScrollIconVisible = 0 < targetElem.scrollHeight - targetElem.clientHeight;
        if (this.isScrollIconVisible) {
          const self = this;
          const scrollEvent = function(e) {
            clearTimeout(self.scrollIconVisibleTimer);
            self.isScrolled = true;
            self.isScrollIconVisible = false;
            targetElem.removeEventListener("scroll", scrollEvent);
          };
          clearTimeout(this.scrollIconVisibleTimer);
          this.scrollIconVisibleTimer = setTimeout(scrollEvent, constants.SCROLL_ICON_VISIBLE_TIME);
          targetElem.addEventListener("scroll", scrollEvent);
        }
      }
    },
    /**
     * ダイアログ表示判定
     *
     * @return {Boolean} true: 表示中, false: 非表示
     */
    isShowDialog: function() {
      var result = false;
      if(this.showLessonScore ||
        this.showSetting ||
        this.showMicrophoneSelect ||
        this.showMicrophoneErrorDialog ||
        this.showCompletionView ||
        this.showScoreReset ||
        this.showProgressHandOver ||
        this.showPinchIn) {
        result = true;
      }
      return result;
    },
    /**
     * モバイルアプリ版：端末電源ON時の開始コールバック
     */
    ROSETTA_SRE_onStart: function() {
      this.log("ROSETTA_SRE_onStart start");
      
      // ダイアログ表示中は何もしない
      if (this.isShowDialog()) {
        return;
      }
      
      // state更新
      this.log("ROSETTA_SRE_onStart set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * モバイルアプリ版：端末電源OFF時の停止コールバック
     */
    ROSETTA_SRE_onStop: function() {
      this.log("ROSETTA_SRE_onStop start");
      // state更新
      this.log("ROSETTA_SRE_onStop set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
      // 音声停止
      this.$emit("audioPause");
    },
    /**
     * ドコモ版：プッシュ通知ダイアログ終了コールバック
     */
    ROSETTA_onPushSetting: function() {
      this.log("ROSETTA_onPushSetting start");
      // state更新
      this.log("ROSETTA_onPushSetting set LessonState: " + storeConstants.LESSON_STATE_RESTART);
      this.$store.dispatch('setLessonState', storeConstants.LESSON_STATE_RESTART);
    },
    /**
     * モバイルアプリ版：アクセスキー無効エラー発生コールバック
     */
    ROSETTA_onErrorAccessKey: function() {
      this.log("ROSETTA_onErrorAccessKey start");
      // state更新
      this.log("ROSETTA_onErrorAccessKey set LessonState: " + storeConstants.LESSON_STATE_PAUSE);
      this.$store.dispatch('setLessonState', storeConstants.LESSON_STATE_PAUSE);
      // 音声停止
      this.$emit('audioPause');
      // エラーダイアログの表示
      var message = "INFO_INVALID_ACCESSKEY";
      this.emitShowError(message, constants.ERROR_BUTTON_KIND_LOGIN);
    }
  },
  created: async function() {
    this.log("Runmode start created");

    // モバイルアプリコールバック設定
    if (!this.isEnvironmentPc()) {
      // モバイルアプリ版：端末電源ON時の開始コールバック設定
      ROSETTA_SRE_onStart = this.ROSETTA_SRE_onStart;
      // モバイルアプリ版：端末電源OFF時の停止コールバック設定
      ROSETTA_SRE_onStop = this.ROSETTA_SRE_onStop;
      // ドコモ版：プッシュ通知ダイアログ終了コールバック設定
      ROSETTA_onPushSetting = this.ROSETTA_onPushSetting;
      // モバイルアプリ版：アクセスキー無効エラー発生コールバック設定
      ROSETTA_onErrorAccessKey = this.ROSETTA_onErrorAccessKey;
    }

    // state更新
    this.log("set LessonState: " + storeConstants.LESSON_STATE_PREPARE);
    this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);

    this.showComponent = true;
    this.levelJson = this.getLevelJson(this.jsonData, this.levelNo);

    // マイク設定が必要な場合、マイク設定画面を表示する
    if (this.$store.getters.sreUse == "true" && (await this.needsMicrophoneSetting(sonic_wrapper.getMicrophone()))) {
      this.showMicSelect();
      return;
    }

    // レッスン準備
    this.prepareLesson();
  },
  mounted: function() {
    this.log("Runmode start mounted");

    // ページが可視状態か取得
    var self = this;
    document.addEventListener("visibilitychange", handler);
    function handler() {
      if (document.visibilityState === "visible") {
        // 戻ってきた場合
        if (self.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
          // ダイアログ表示中は何もしない
          if(self.isShowDialog()) {
            return;
          }
          // state更新して、レッスンを再開
          self.log("Runmode watch visibilitychange: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
          self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
        }
      } else {
        // 別タブへ移動した場合
        self.audioPause();
        self.log("Runmode watch visibilitychange: set lessonState: " + storeConstants.LESSON_STATE_PAUSE);
        self.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PAUSE);
      }
    }
  },
  watch: {
    sreUse: function(newSreUse) {
      if (this.$store.getters.lessonState !== storeConstants.LESSON_STATE_PAUSE) {
        return;
      }

      // SREを使用するrunmodeか確認
      var index = constants.RUNMODE_NOT_USE_SRE.indexOf(this.currentMode);
      if (index == -1) {
        // SREを使用するので、state更新して、レッスンを再実施
        this.log("Runmode watch sreUse: set lessonState: " + storeConstants.LESSON_STATE_PREPARE);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);
        this.doStartLesson();
      } else {
        // SREを使用しないので、state更新して、レッスンを再開
        this.log("Runmode watch sreUse: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    textSize: function(newState) {
      // 設定画面にて文字サイズ変更時は再表示
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_PREPARE);
      this.doStartLesson();
    },
    showLessonScore: function(newShowLessonScore) {
      // レッスンスコア画面が表示された場合は何もしない
      if (newShowLessonScore) {
        return;
      }

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        this.showScoreReset = false;

        // state更新して、レッスンを再開
        this.log("Runmode watch showLessonScore: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    showSetting: function(newShowSetting) {
      // 設定画面が表示された場合は何もしない
      if (newShowSetting) {
        return;
      }

      if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("Runmode watch showSetting: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
      }
    },
    showMicrophoneSelect: function(newShowMicrophoneSelect) {
      // マイク選択画面が表示された場合は何もしない
      if (newShowMicrophoneSelect) {
        return;
      }

      // マイク設定確認ダイアログからのマイク選択画面か確認
      if (this.showMicrophoneErrorDialog) {
        this.showMicrophoneErrorDialog = false;

        if (this.$store.getters.lessonState === storeConstants.LESSON_STATE_PAUSE) {
          // state更新して、レッスンを再開
          this.log("Runmode watch showMicrophoneSelect: set lessonState: " + storeConstants.LESSON_STATE_RESTART);
          this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_RESTART);
        }
      } else if (!this.showSetting) {
        // 設定画面が表示されていなければレッスン準備
        this.prepareLesson();
      }
    },
    clickToolbarLogo: function(newLogo) {
      if (!newLogo) {
        // 何もしない
        return;
      }

      // state更新
      this.log("set LessonState: " + storeConstants.LESSON_STATE_STOP);
      this.$store.dispatch("setLessonState", storeConstants.LESSON_STATE_STOP);
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/style/runmode_common";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Runmode.vue?f9087858